export function capitalize(str: string): string {
    return str.substr(0, 1).toUpperCase() + str.substr(1, str.length - 1);
}

export function format(value: string, replacements: {}) {
    return value.replace(/{([^{}]*)}/g, (a, b) => {
        let r = replacements[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
}

export function getPixelAmountFromStyle(pixels: string) {
    return +pixels.substring(0, pixels.indexOf('px'));
}
